import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth, homeFor } from "@/context/AuthContext";
import { toast } from "sonner";
import SidiLogo from "@/components/SidiLogo";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid }, { withCredentials: true });
        setSession(data.token, data.user);
        window.history.replaceState(null, "", window.location.pathname);
        const u = data.user;
        nav(homeFor(u.role), { replace: true, state: { user: u } });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Connexion Google échouée");
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4" data-testid="auth-callback">
      <SidiLogo size={72} />
      <div className="text-[11px] tracking-[0.3em] uppercase text-[var(--text-muted)]">Authentification Google…</div>
    </div>
  );
}
